import { render, staticRenderFns } from "./checkbox-defaultValue-editor.vue?vue&type=template&id=b77e89ba&scoped=true&"
import script from "./checkbox-defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./checkbox-defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77e89ba",
  null
  
)

export default component.exports